import { render, staticRenderFns } from "./Experimental.vue?vue&type=template&id=f271610a&scoped=true&"
import script from "./Experimental.vue?vue&type=script&lang=js&"
export * from "./Experimental.vue?vue&type=script&lang=js&"
import style0 from "./Experimental.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Experimental.vue?vue&type=style&index=1&id=f271610a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f271610a",
  null
  
)

export default component.exports